var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper",class:[
        _vm.cam.icon,
        {
        'icon-wrapper--preview': _vm.type === 'preview',
        'alarm-background': _vm.isAlarm,
        'cam-highlight': _vm.isHighlight
        }
    ],on:{"click":function($event){_vm.type === 'map' ? _vm.$emit('click') : ''}}},[_c('div',{staticClass:"icon-cam",style:(_vm.styleIcon),attrs:{"title":_vm.$t(("CAM_" + (_vm.cam.status.state)))}}),_vm._v(" "),_c('div',{staticClass:"icon-cam-status"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc5b9682","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/iconCam/IconCam.vue
// module id = 623
// module chunks = 1